// https://www.youtube.com/oembed?url=http%3A//youtube.com/watch%3Fv%3DNX9DTboxWVY&format=json

import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { LectureApiBase } from './lecture-api'

export interface YoutubeOEmbed {
  version: string
  type: string
  title: string
  width: number
  height: number
  authorName: string
  html: string
  providerUrl: string
  authorUrl: string
  provider_name: string
  thumbnailWidth: number
  thumbnailHeight: number
  thumbnailUrl: string
}

@Injectable()
export class YoutubeOEmbedApi {
  constructor(
    private api: LectureApiBase,
  ) { }

  fetch(videoId: string): Observable<YoutubeOEmbed> {
    return this.api.get(this.api.makeUrlWithParams('youtube_oembed' , { videoId }))
  }
}



// WEBPACK FOOTER //
// ./src/apis/youtube-oembed.ts